<template>
  <div class="dialog-footer" :class="{ 'full-footer': fullFlag, 'is-process': ifProcess }">
    <div class="input-container">
      <div class="input-warp">
        <textarea
          class="input-box"
          ref="contentInputRef"
          v-model="question"
          placeholder="请将您遇到的问题告诉我，使用 Shift + Enter 换行"
          :style="{ height: textareaHeight + 'px' }"
          @keydown.enter="handleKeyCode"
          @input="adjustHeight"
        ></textarea>
        <div class="text-warp">{{ question }}</div>
      </div>
      <div class="tool-warp">
        <div
          :class="['deep-think', { active: ifDeepThink }]"
          @click="handleDeepThink"
        >
          <vector-active-icon v-if="ifDeepThink" class="vector-icon" />
          <vector-icon v-else class="vector-icon" />
          深度思考
        </div>
        <div class="append">
          <el-tooltip
            :content="ifProcess ? '停止对话' : '发送消息'"
            placement="top"
          >
            <stop-icon
              v-if="ifProcess"
              class="stop-icon"
              @click="stopDialog"
            />
            <send-icon
              v-else
              class="send-icon"
              @click="addDialog"
            />
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="tips-warp">
      <span class="color-red">*&nbsp;</span>
      <span>回答内容由 AI 生成，仅供参考，任何情况下，公司不对任何人因使用本产品回答内容所引致的损失负任何法律责任。</span>
    </div>
  </div>
</template>

<script>
import SendIcon from "@/assets/svg/send.svg";
import StopIcon from "@/assets/svg/stop.svg";
import VectorIcon from "@/assets/svg/Vector.svg";
import VectorActiveIcon from "@/assets/svg/Vector-active.svg";
import { setAiIfDeepThink } from "@/utils/localStorageTool.js";

export default {
  props: {
    fullFlag: Boolean, // 是否全屏
  },
  components: {
    SendIcon,
    StopIcon,
    VectorIcon,
    VectorActiveIcon,
  },
  data() {
    return {
      // 输入框内容
      question: "",
      textareaHeight: 20,
    };
  },
  computed: {
    ifDeepThink() {
      return this.$store.state.ifDeepThink;
    },
    ifProcess() {
      return this.$store.state.ifProcess;
    },
    ifFullStyle() {
      return this.$store.state.layout === 'fullscreen';
    }
  },
  watch: {
    'ifDeepThink': (newVal) => {
      setAiIfDeepThink(newVal);
    },
  },
  methods: {
    /**
     * 设置问题内容
     * @param question 
     */
    setQuestion(question) {
      this.question = question;
    },
    // 调整高度
    adjustHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.contentInputRef;
        if (!textarea) return;
        textarea.style.height = "auto"; // 先重置高度
        this.textareaHeight = textarea.scrollHeight; // 根据内容调整
      });
    },
    adjustPromptHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.promptInputRef;
        if (!textarea) return;
        textarea.style.height = "auto"; // 先重置高度
      })
    },
    // 点击深度思考
    handleDeepThink() {
      const newVal = !this.ifDeepThink;
      this.$store.commit('setIfDeepThink', newVal);
      window.parent.postMessage({
				type: 'chatServiceEvent',
				eventType: 'postIfDeepThink',
				data: {
					ifDeepThink: newVal,
				}
			}, '*')
    },
    // 键盘回车事件
    handleKeyCode(event) {
      if (event.keyCode == 13) {
        if (!event.shiftKey) {
          event.preventDefault();
          this.addDialog();
          this.adjustHeight();
        } else {
          this.adjustHeight();
        }
      }
    },
    // 添加对话
    addDialog() {
      if (this.question.trim() === "") {
        this.$message.warning("请输入问题");
        this.question = "";
        this.adjustHeight();
        return;
      }
      const currentQuestion = this.question;
      this.$emit("addDialog", currentQuestion);
      this.question = "";
    },
    // 停止对话
    stopDialog() {
      this.$emit("stopDialog");
    },
    // focus到输入框
    focusToText () {
      this.$refs.contentInputRef.focus();
    },
  },
  created() {},
  mounted() {
    this.adjustHeight(); // 初始化高度
  },
};
</script>

<style scoped lang="less">
.dialog-footer {
    // min-height: 45px;
    // padding: 14px 21px;
    position: relative;
    margin-bottom: 10px;
    .input-container {
      //// new style
      cursor: text;
      padding-top: 12px;
      padding-bottom: 10px;
      background-color: #f8f8f8;
      border-radius: 8px;
      box-sizing: border-box;
      margin: 0 21px;
      border: 1px solid #dbdcdc;
      padding-left: 20px;
      .input-warp {
        max-height: 200px;
        position: relative;
        margin-right: 10px;
        overflow: hidden;
        .text-warp {
          visibility: hidden;
          pointer-events: none;
          width: 100%;
          min-height: 20px;
          word-break: break-all;
          white-space: pre-wrap;
        }
        .input-box {
          position: absolute;
          width: 100%;
          min-height: 20px;
          background-color: transparent;
          resize: none;
          font-family: Siyuanhei !important;
          word-break: break-word !important;
          white-space: pre-wrap !important;
          color: rgba(29, 29, 31, 0.95);
          display: block;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          overflow: auto;
          border: none;
          width: 100%;
          height: auto;
          margin: 0;
          padding: 0;
          font-size: 14px;
          box-sizing: border-box;
          &::placeholder {
            color: #9c9c9d;
          }
        }
      }
      .tool-warp {
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 7px;
        .deep-think {
          width: 90px;
          height: 28px;
          border: 1px solid #d7d7d7;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333;
          cursor: pointer;
          user-select: none;
          line-height: 22px;
          font-weight: 400;
          font-size: 12px;
          .vector-icon {
            margin-right: 8px;
            width: 11px;
            height: 11px;
          }
          &:hover {
            opacity: 0.8;
          }
          &:active {
            transform: scale(0.98);
          }
          &.active {
            background: linear-gradient(90deg, #928fe8 0%, #f8bccf 100%);
            text-fill: transparent;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            border-color: #ee33dd33;
          }
        }
        .append {
          position: absolute;
          bottom: -12px;
          right: 20px;
          cursor: pointer;
          background: url(../../assets/imgs/send-bg.png) no-repeat;
          background-size: contain;
          width: 61px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          .stop-icon {
            width: 12px;
            height: 12px;
          }
          svg {
            // width: 19px;
            // height: 19px;
            color: #fff;
          }
        }
      }
    }
    .tips-warp {
      font-weight: 400;
      font-size: 12px;
      color: #989898;
      text-align: center;
      margin: 10px 0;
      padding: 0 20px;
      line-height: 16px;
    }
    // 全屏样式
    &.full-footer {
      width: clamp(797px, 797px, 90%);
      margin: 0 auto 10px auto;
      .tips-warp {
        margin: 14px 0 0 0;
      }
      .input-container {
        padding-left: 20px;
        margin: 0;
        .deep-think {
          left: 325px;
        }
        .append {
          position: absolute;
          right: 20px;
          cursor: pointer;
        }
      }
    }
  }

// 添加content内容底部样式
.dialog-footer {
  position: relative;
}
.is-process::before {
  content: "";
  top: -47px;
  left: 0;
  height: 47px;
  width: 100%;
  position: absolute;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 76.5%);
}
.color-red {
  color: #fe2a20;
  font-weight: bold;
  font-size: 20px;
  vertical-align: -8px;
}
</style>